/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';
import Picture from '../common/picture';

export default class StudentJobDetail extends Transformer {
  /**
   * @param studentJob
   *
   * @returns {Object} The transformed account
   */
  static fetch(student) {
    return {
      id: student.id,
      firstName: student.firstname,
      lastName: student.lastname,
      shortName: student.short_name,
      gender: student.gender,
      school: student.school,
      studies: student.studies,
      commentUnique: student.comment_unique,
      threeAdjectives: student.three_adjectives,
      kpi: student.kpi,
      geoPools: student.geo_pools,
      mainPicture: student.main_picture && student.main_picture.format ? student.main_picture.format.small : null,
      pictureHostess: student.picture_hostess ? Picture.fetch(student.picture_hostess) : null,
      pictureHostessFull:
        student.picture_hostess_full
          ? Picture.fetch(student.picture_hostess_full) : null,
      birthdayDate: student.birthday_date,
      softSkillsRatedByCustomer: student.soft_skills_rated_by_customer,
    };
  }
}
